import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import { withStyles } from "@material-ui/core/styles";

const defaultToolbarSelectStyles = {
  iconButton: {
    marginRight: "24px",
    top: "50%",
    display: "inline-block",
    position: "relative",
    transform: "translateY(-50%)"
  },
  deleteIcon: {
    color: "#000"
  }
};

class CustomToolbarSelect extends React.Component {
    constructor(props) {
        super(props);
        this.props=props;
    }
        
    handleMoveClick = () => {
        //console.log(this.props.selectedRows);
        this.props.moveHandler(this.props.selectedRows);
    };

    handleDeleteClick = () => {
        //console.log(this.props.selectedRows);
        this.props.deleteHandler(this.props.selectedRows);
    };

    render() {
        const { classes } = this.props;

        return (
        <div className={"custom-toolbar-select"}>
            <Tooltip title={"Move claims to send file"}>
            <IconButton className={classes.iconButton} onClick={this.handleMoveClick}>
                <PlayArrowIcon className={classes.deleteIcon} />
            </IconButton>
            </Tooltip>
            <Tooltip title={"Delete selected claims"}>
            <IconButton className={classes.iconButton} onClick={this.handleDeleteClick}>
                <DeleteIcon className={classes.deleteIcon} />
            </IconButton>
            </Tooltip>
        </div>
        );
    }
}

export default withStyles(defaultToolbarSelectStyles, {
  name: "CustomToolbarSelect"
})(CustomToolbarSelect);
